import { Tooltip } from "radix-ui";
import type { ReactNode } from "react";

/** Put once around the app shell: tooltips open after a short pause and move instantly between neighbours. */
export function TooltipProvider({ children }: { children: ReactNode }) {
  return <Tooltip.Provider delayDuration={250}>{children}</Tooltip.Provider>;
}

/**
 * A short label shown beside an element on hover or keyboard focus (e.g. an icon-only menu item). With
 * `enabled={false}` the element renders on its own, so the same markup works with and without the tooltip.
 */
export function Tip({
  label,
  side = "right",
  enabled = true,
  children,
}: {
  label: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  enabled?: boolean;
  /** One element that can take a ref (a link or a button). */
  children: ReactNode;
}) {
  if (!enabled) return children;
  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          side={side}
          sideOffset={8}
          className="z-50 rounded-lg bg-ink px-2.5 py-1.5 text-[13px] font-semibold text-bg shadow-lg"
        >
          {label}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
}
